import { useMemo } from "react";
import { useMe } from "../../hooks/useMe";
import { useMyCases } from "../../hooks/useMyCases";
import ArchivePage from "../archive/archive";
import CasesList from "../archive/case-list/case-list";

function PortalHome() {
  const me = useMe();
  const isAdmin = useMemo(() => me?.isAdmin, [me?.isAdmin]);

  if (isAdmin) return <ArchivePage />;

  return <PortalInner />;
}

function PortalInner() {
  const me = useMe();
  const myCases = useMyCases(me?.email);

  return (
    <div className="p-content">
      <div className="p-pagehead">
        <div>
          <div className="p-breadcrumb">Workspace</div>
          <h1 className="p-pagetitle">My Cases</h1>
        </div>
      </div>

      {me?.email ? (
        <div className="p-card">
          <CasesList query="" cases={myCases} />
        </div>
      ) : (
        <div style={{ padding: "48px 0", textAlign: "center", color: "var(--ink-soft)" }}>Loading…</div>
      )}
    </div>
  );
}

export default PortalHome;
